

































import { defineComponent } from "@vue/composition-api";
import NumberFormatter from "@/services/number.formatter";
import { BlockLabel } from "@/models/BlockLabel";
import { Expandable, TextField } from "@/components";

export default defineComponent({
  name: "SingleAmount",
  components: {
    Expandable,
    TextField,
  },
  props: {
    blockId: {
      type: Number,
      required: true,
    },
    isExpanded: {
      type: Boolean,
      default: false,
    },
    data: { type: Object, default: null },
  },
  data() {
    return {
      amount: 1000,
      displayName: BlockLabel.SingleAmount,
      description: "",
    };
  },
  mounted() {
    if (this.data) {
      this.amount = this.data.amount;
      this.description = this.data.description;
    }
  },
  methods: {
    expandBlock() {
      this.$emit("setBlockExpanded", this.blockId);
    },
    collapseBlock() {
      this.$emit("updateBlock", {
        blockId: this.blockId,
        type: this.$options.name,
        amount: this.amount,
        description: this.description,
      });
    },
    asCurrency(number: number) {
      return `kr ${NumberFormatter.withThousandsSeparator(number, " ")}`;
    },
  },
});
